import { createFileRoute } from "@tanstack/react-router";

import { ReviewsPage } from "@/pages/Reviews/ReviewsPage";
import { requireReviewer } from "@/utils/routeGuards";

export const Route = createFileRoute("/app/reviews")({
  beforeLoad: async ({ location }) => {
    await requireReviewer(location);
  },
  component: ReviewsPage,
});
